/**
 * Created by andrey on 13.05.2022.
 */

const UserClan = function (...args) {
    Clan.apply(this, ...args);

    this.loadSave();
    this.load();
};

UserClan.prototype = Object.create(Clan.prototype);
UserClan.prototype.constructor = UserClan;

UserClan.prototype.loadRequest = function (onSuccess, onFailure, options) {
    cleverapps.RestClient.get(`${connector.config.multiApiURL}/clans/${connector.config.projectId}/userclan/${encodeURIComponent(connector.platform.getUserID())}`, {}, (data) => {
        onSuccess(data);

        this.updateProfile();
    }, onFailure, options);
};

UserClan.prototype.updateProfile = function () {
    if (this.id === undefined) {
        return;
    }

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/${connector.config.projectId}/updateprofile`, {
        userId: connector.platform.getUserID(),
        name: connector.player.name,
        avatar: connector.player.avatar,
        level: GameLevelHelper.GetMainInstance().getLevel()
    });
};

UserClan.prototype.changeUserId = function (oldUserId, newUserId) {
    this.setOldUserId(oldUserId);

    cleverapps.RestClient.post(`${connector.config.multiApiURL}/clans/${connector.config.projectId}/changeuserid`, { oldUserId, newUserId }, (data) => {
        console.log("changeUserId result", data);

        if (!data || !data.error) {
            this.setOldUserId(undefined);
        }
    });
};

UserClan.prototype.loadSave = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.USER_CLAN);
    this.oldUserId = data && data.oldUserId;

    if (this.oldUserId === connector.platform.getUserID()) {
        this.setOldUserId(undefined);
    }

    if (this.oldUserId) {
        this.changeUserId(this.oldUserId, connector.platform.getUserID());
    }
};

UserClan.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.USER_CLAN, { oldUserId: this.oldUserId });
};

UserClan.prototype.setOldUserId = function (oldUserId) {
    if (this.oldUserId !== oldUserId) {
        this.oldUserId = oldUserId;
        this.save();
    }
};
